import { Navigate } from 'react-router-dom';
import { opensOnMorning, pacificDate } from './todos/todoFormat';

/** The Pacific date the home-screen app last started on the Morning page - per device, a convenience only. */
export const MORNING_DAY_KEY = 'apex.morningOpenedDay';

const read = (): string | null => {
  try { return localStorage.getItem(MORNING_DAY_KEY); } catch { return null; }
};
const isStandalone = (): boolean => {
  try {
    return window.matchMedia?.('(display-mode: standalone)').matches === true
      || (navigator as Navigator & { standalone?: boolean }).standalone === true; // iOS home-screen app
  } catch { return false; }
};

/**
 * "/" - the app's start page (the manifest's start_url). His words, 2026-10-26: open on the Morning page "but only in the
 * morning": the installed app's FIRST open of a Pacific day between 5 AM and noon goes to /morning; every other open,
 * and every browser tab, goes to the dashboard as before. ⭐ Storage failing (a private window) only means Morning may
 * show again - it never blocks the app.
 */
export default function HomeRedirect() {
  const now = new Date();
  if (opensOnMorning({ now, standalone: isStandalone(), lastMorningDay: read() })) {
    try { localStorage.setItem(MORNING_DAY_KEY, pacificDate(now)); } catch { /* a convenience: see above */ }
    return <Navigate to="/morning" replace />;
  }
  return <Navigate to="/dashboard" replace />;
}
